import React from "react";
import WPLink from "../wpLink";
import FixedImage from "../fixedImage";
import useDroidalLink from "../../helpers/useDroidalLink";

/**
 * Renders a link to the first Droidal template page (via WPLink) using the same
 * text/classes/icon as the original modal trigger button. When no Droidal page
 * exists, renders an inert button with the same appearance that does nothing.
 *
 * `wrapperProps` (e.g. data-sal animation attributes) are applied to a wrapping
 * span so any scroll animations on the original button are preserved.
 */
const DroidalLink = ({ text, passedClass, icon = null, passedIconClass = null, wrapperProps = null }) => {
	const droidalLink = useDroidalLink();

	if (!text) {
		return null;
	}

	const content = droidalLink ? (
		<WPLink
			link={{ url: droidalLink, title: text, target: "" }}
			passedClass={passedClass}
			icon={icon}
			passedIconClass={passedIconClass}
		/>
	) : (
		<button className={passedClass} type="button">
			{text} {icon !== null ? <FixedImage image={icon} passedClass={passedIconClass} /> : null}
		</button>
	);

	return wrapperProps ? <span {...wrapperProps}>{content}</span> : content;
};

export default DroidalLink;
